import { usePartnerId, useRetailerId } from '../../../../utils/routing/params.hooks'
import { storeGroupListDefaultParams } from '../../../common/graphql/store-groups/list.hooks'
import { ListStoreGroupsDocument, useCreateStoreGroupMutation } from '../../../../__codegen__/api'

interface CreateProps {
  name: string
  retailerLocationIds: string[]
}

export const useCreateStoreGroup = () => {
  const partnerId = usePartnerId()

  const [triggerCreateStoreGroup, { data, error, loading }] = useCreateStoreGroupMutation()

  const createStoreGroup = ({ name, retailerLocationIds }: CreateProps) =>
    triggerCreateStoreGroup({
      variables: {
        partnerId,
        name,
        retailerLocationIds,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: ListStoreGroupsDocument,
          variables: {
            ...storeGroupListDefaultParams,
            partnerId,
          },
        },
      ],
    })

  const createdStoreGroup = data && data.retailerLocationGroupCreate.retailerLocationGroup

  return {
    createStoreGroup,
    createdStoreGroup,
    loading,
    error,
  }
}
